<style>
    .cdk-overlay-container {
        z-index: 2000;
    }

    svg:focus {
        outline: none !important;
    }

    button:focus {
        outline: none !important;
    }
</style>



<div class=" modal-content"
    style="border-radius:0px; font-family: sans-serif !important; height: 100%; overflow: hidden; margin: 0px; padding: 0px; width: 100% !important; position: relative; background-color: #f1f1f3 !important;">
    <div>
        <!--Header-->
        <div style="padding: 15px 20px 0px 20px; display: flex; position: sticky; top: 0; z-index: 2; background-color: #f1f1f3;">
            <!-- WebView Header-->
            <div class="col-md-6 col-sm-6 col-6 webView">
                <div class="row">
                    <div class="col-md-12 col-12" style="padding-left: 0px;">
                        <h4 class="modal-title" style="margin-bottom: 15px;"><span id="ApntmntHdr">Inventory Import (Corrections)</span>
                        </h4>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-6" style="text-align: right;">
                <div style="display: inline-block; margin-right: 7px;" *ngIf="error.showError && error.apiResponse == false && showIgnoreErr">
                    <label style="font-weight: 500; cursor: pointer; font-size: 13px !important; line-height: 3;">
                        <input type="checkbox" [(ngModel)]="error.ignoreErrors" style="vertical-align: middle; margin-right: 3px; color: #dee2e6;"/> Ignore Errors
                    </label>
                </div>
                <button *ngIf="error.showError && error.apiResponse == false && showIgnoreErr" type="button" style="color: #15304a; background-color: #15304a22; border-radius: 3px; border: 1px solid #15304a; margin-right: 5px; padding: 1px 10px;" data-toggle="tooltip" data-placement="bottom" title="Ignore errors that are not in mandatory fields (*)"><i class="fa fa-info" aria-hidden="true"></i>
                </button>
                <button class="btn darkBlueButton brdrRadius3" (click)="goToPreviousErr()" [disabled]="isPreviousDisabled"
                    style="font-size: 14px; padding: 3x 10px !important; line-height: 1.66em; margin-left: 10px;">
                    <i class="fa fa-chevron-up" style="margin-right: 5px;"></i>
                    <span>Previous Error</span>
                </button>
                <button class="btn darkBlueButton brdrRadius3" (click)="goToNextErr()" [disabled]="isNextDisabled"
                    style="font-size: 14px; padding: 3x 10px !important; line-height: 1.66em; margin-left: 10px;">
                    <span>Next Error</span>
                    <i class="fa fa-chevron-down" style="margin-left: 5px;"></i>
                </button>
                <span class="btn darkGreenButton brdrRadius3" (click)="save()"
                    style="font-size: 14px; padding: 3x 10px !important; line-height: 1.66em; margin-left: 10px;">
                    <i class="fa fa-check" style="margin-right: 5px;"></i>
                    <span>Save</span>
                </span>
            </div>
        </div>

        <!--Body-->
        <div class="modal-body" style="margin: 0px; padding: 0px 15px 0px 20px;">
            <!--Body-->

            <!-- Wbview -> Voucher Type + Voucher No-->
            <div class="col-md-12 col-12 col-12 pad0 webView">
                <!--Import Items Table-->
                <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 0;">
                    <div class="row" style="margin: 0px;">
                        <!-- WebView -->
                        <div class="col-md-12" style="padding: 0px;">
                            <!-- table.component.html -->
                            <div *ngIf="importData.length > 0" class="table-container">
                                <div class="table-wrapper">
                                <div class="scrollable-table">
                                    <table mat-table [dataSource]="dataSource">
                                    <!-- No. Column -->
                                    <ng-container matColumnDef="No.">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-50 sticky-header"> No. </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-50" style="vertical-align: baseline;">
                                        {{item.srNo}}
                                        </td>
                                    </ng-container>
                            
                                    <!-- Item Name Column -->
                                    <ng-container matColumnDef="ItemName">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-250 sticky-header">
                                            Item Name <span class="required-marker">*</span>
                                        </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-250" style="vertical-align: baseline;">
                                        <div class="cell-wrapper">
                                            <div class="cell-content">
                                                <input
                                                    type="text"
                                                    [(ngModel)]="item.itemName"
                                                    [ngClass]="{'form-control': true, 'error-border': item.errID.includes(1), 'normal': !item.errID.includes(1), 'error': item.errID.includes(1)}"
                                                    (blur)="validateField('itemName', item.srNo - 1)"
                                                    style="width: 100%;"
                                                />
                                            </div>
                                            <div class="error-messages">
                                                <div *ngFor="let e of item.errors" style="margin-top: 2px;">
                                                    <span *ngIf="e.errID == 1" style="color: red;">• {{e.errorMsg}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        </td>
                                    </ng-container>
                            
                                    <!-- Code Column -->
                                    <ng-container matColumnDef="Code">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-150 sticky-header"> 
                                            Code 
                                            <span class="required-marker" style="left: 40px;">*</span>
                                        </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-150" style="vertical-align: baseline;">
                                        <div class="cell-wrapper">
                                            <div class="cell-content">
                                                <input
                                                    type="text"
                                                    [(ngModel)]="item.itemCode"
                                                    [ngClass]="{'form-control': true, 'error-border': item.errID.includes(2), 'normal': !item.errID.includes(2), 'error': item.errID.includes(2)}"
                                                    (blur)="validateField('itemCode', item.srNo - 1)"
                                                    style="width: 100%;"
                                                />
                                            </div>
                                            <div class="error-messages">
                                                <div *ngFor="let e of item.errors" style="margin-top: 2px;">
                                                    <span *ngIf="e.errID == 2" style="color: red;">• {{e.errorMsg}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        </td>
                                    </ng-container>
                            
                                    <!-- Category Column -->
                                    <ng-container matColumnDef="Category">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-150 sticky-header"> 
                                            Category 
                                            <span class="required-marker" style="left: 62px;">*</span>
                                        </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-150" style="vertical-align: baseline;">
                                            <select
                                                [(ngModel)]="item.category"
                                                (change)="onCategoryChange(item)"
                                                [ngClass]="{'form-control': true, 'error-border': item.errID.includes(3), 'normal': !item.errID.includes(3), 'error': item.errID.includes(3)}"
                                                (blur)="validateField('category', item.srNo - 1)"
                                                style="width: 100%;"
                                            >
                                                <option value="" disabled selected>Select Category</option>
                                                <option *ngFor="let category of catList" [value]="category.cnm">{{ category.cnm }}</option>
                                            </select>   
                                            <div class="error-messages">
                                                <div *ngFor="let e of item.errors" style="margin-top: 2px;">
                                                    <span *ngIf="e.errID == 3" style="color: red;">• {{e.errorMsg}}</span>
                                                </div>
                                            </div>
                                        </td>
                                    </ng-container>
                            
                                    <!-- Sub Category Column -->
                                    <ng-container matColumnDef="SubCategory">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-150 sticky-header"> 
                                            Sub-Category 
                                            <span class="required-marker" style="left: 90px;">*</span>
                                        </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-150" style="vertical-align: baseline;">
                                            <select
                                                [(ngModel)]="item.subCategory"
                                                [ngClass]="{'form-control': true, 'error-border': item.errID.includes(4), 'normal': !item.errID.includes(4), 'error': item.errID.includes(4)}"
                                                (blur)="validateField('subCategory', item.srNo - 1)"
                                                style="width: 100%;"
                                            >
                                                <option value="" disabled selected>Select Sub-Category</option>
                                                <option *ngFor="let subCategory of getSubCategories(item.category)" [value]="subCategory.snm">{{ subCategory.snm }}</option>
                                            </select>
                                            <div class="error-messages">
                                                <div *ngFor="let e of item.errors" style="margin-top: 2px;">
                                                    <span *ngIf="e.errID == 4" style="color: red;">• {{e.errorMsg}}</span>
                                                </div>
                                            </div>
                                        </td>
                                    </ng-container>
                            
                                    <!-- Type Column -->
                                    <ng-container matColumnDef="Type">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-100 sticky-header"> 
                                            Type 
                                            <span class="required-marker" style="left: 35px;">*</span>
                                        </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-120" style="vertical-align: baseline;">
                                            <select
                                                [(ngModel)]="item.type"
                                                [ngClass]="{'form-control': true, 'error-border': item.errID.includes(5), 'normal': !item.errID.includes(5), 'error': item.errID.includes(5)}"
                                                (blur)="validateField('type', item.srNo - 1)"
                                                style="width: 100%;"
                                            >
                                                <option value="" disabled selected>Select Type</option>
                                                <option *ngFor="let itemtype of itemType" [value]="itemtype.type">{{ itemtype.type }}</option>
                                            </select>
                                            <div class="error-messages">
                                                <div *ngFor="let e of item.errors" style="margin-top: 2px;">
                                                    <span *ngIf="e.errID == 5" style="color: red;">• {{e.errorMsg}}</span>
                                                </div>
                                            </div>
                                        </td>
                                    </ng-container>
                            
                                    <!-- Standard Cost Column -->
                                    <ng-container matColumnDef="StdCost">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-100 sticky-header"> Std Cost (₹) </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-100" style="vertical-align: baseline;">
                                        <div class="cell-wrapper">
                                            <div class="cell-content">
                                                <input
                                                    type="text"
                                                    [(ngModel)]="item.stdCost"
                                                    [ngClass]="{'form-control': true, 'error-border': item.errID.includes(6), 'normal': !item.errID.includes(6), 'error': item.errID.includes(6)}"
                                                    (blur)="validateField('stdCost', item.srNo - 1)"
                                                    style="width: 100%; text-align: right;"
                                                />
                                            </div>
                                            <div class="error-messages">
                                                <div *ngFor="let e of item.errors" style="margin-top: 2px;">
                                                    <span *ngIf="e.errID == 6" style="color: red;">• {{e.errorMsg}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        </td>
                                    </ng-container>
                            
                                    <!-- Purchase Cost Column -->
                                    <ng-container matColumnDef="PurchCost">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-100 sticky-header"> Purch Cost (₹) </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-100" style="vertical-align: baseline;">
                                        <div class="cell-wrapper">
                                            <div class="cell-content">
                                                <input
                                                    type="text"
                                                    [(ngModel)]="item.purchCost"
                                                    [ngClass]="{'form-control': true, 'error-border': item.errID.includes(7), 'normal': !item.errID.includes(7), 'error': item.errID.includes(7)}"
                                                    (blur)="validateField('purchCost', item.srNo - 1)"
                                                    style="width: 100%; text-align: right"
                                                />
                                            </div>
                                            <div class="error-messages">
                                                <div *ngFor="let e of item.errors" style="margin-top: 2px;">
                                                    <span *ngIf="e.errID == 7" style="color: red;">• {{e.errorMsg}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        </td>
                                    </ng-container>
                            
                                    <!-- Standard Sale Price Column -->
                                    <ng-container matColumnDef="StdSalePrice">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-120 sticky-header"> Std Sale Price (₹) </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-120" style="vertical-align: baseline;">
                                        <div class="cell-wrapper">
                                            <div class="cell-content">
                                                <input
                                                    type="text"
                                                    [(ngModel)]="item.stdSalePrice"
                                                    [ngClass]="{'form-control': true, 'error-border': item.errID.includes(8), 'normal': !item.errID.includes(8), 'error': item.errID.includes(8)}"
                                                    (blur)="validateField('stdSalePrice', item.srNo - 1)"
                                                    style="width: 100%; text-align: right"
                                                />
                                            </div>
                                            <div class="error-messages">
                                                <div *ngFor="let e of item.errors" style="margin-top: 2px;">
                                                    <span *ngIf="e.errID == 8" style="color: red;">• {{e.errorMsg}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        </td>
                                    </ng-container>
                            
                                    <!-- Initial Quantity Column -->
                                    <ng-container matColumnDef="InitialQty">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-100 sticky-header"> 
                                            Initial Qty 
                                            <span class="required-marker" style="left: 62px;">*</span>
                                        </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-100" style="vertical-align: baseline;">
                                        <div class="cell-wrapper">
                                            <div class="cell-content">
                                                <input
                                                    type="text"
                                                    [(ngModel)]="item.initialQty"
                                                    [ngClass]="{'form-control': true, 'error-border': item.errID.includes(9), 'normal': !item.errID.includes(9), 'error': item.errID.includes(9)}"
                                                    (blur)="validateField('initialQty', item.srNo - 1)"
                                                    style="width: 100%; text-align: right"
                                                />
                                            </div>
                                            <div class="error-messages">
                                                <div *ngFor="let e of item.errors" style="margin-top: 2px;">
                                                    <span *ngIf="e.errID == 9" style="color: red;">• {{e.errorMsg}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        </td>
                                    </ng-container>
                            
                                    <!-- Unit Column -->
                                    <ng-container matColumnDef="Unit">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-100 sticky-header"> Unit </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-80" style="vertical-align: baseline;">
                                            <select
                                                [(ngModel)]="item.unit"
                                                [ngClass]="{'form-control': true, 'error-border': item.errID.includes(10), 'normal': !item.errID.includes(10), 'error': item.errID.includes(10)}"
                                                (blur)="validateField('unit', item.srNo - 1)"
                                                style="width: 100%;"
                                            >
                                                <option value="" disabled selected>Select Unit</option>
                                                <option *ngFor="let unit of unitList" [value]="unit.UNm">{{ unit.UNm }}</option>
                                            </select>   
                                            <div class="error-messages">
                                                <div *ngFor="let e of item.errors" style="margin-top: 2px;">
                                                    <span *ngIf="e.errID == 10" style="color: red;">• {{e.errorMsg}}</span>
                                                </div>
                                            </div>
                                        </td>
                                    </ng-container>
                            
                                    <!-- Store Column -->
                                    <ng-container matColumnDef="Store">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-100 sticky-header"> 
                                            Store
                                            <span class="required-marker" style="left: 38px;">*</span>
                                        </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-150" style="vertical-align: baseline;">
                                            <select
                                                [(ngModel)]="item.store"
                                                [ngClass]="{'form-control': true, 'error-border': item.errID.includes(11), 'normal': !item.errID.includes(11), 'error': item.errID.includes(11)}"
                                                (blur)="validateField('store', item.srNo - 1)"
                                                style="width: 100%;"
                                            >
                                                <option value="" disabled selected>Select Store</option>
                                                <option *ngFor="let store of storeList" [value]="store.sNm">{{ store.sNm }}</option>
                                            </select>
                                            <div class="error-messages">
                                                <div *ngFor="let e of item.errors" style="margin-top: 2px;">
                                                    <span *ngIf="e.errID == 11" style="color: red;">• {{e.errorMsg}}</span>
                                                </div>
                                            </div>
                                        </td>
                                    </ng-container>
                            
                                    <!-- HSN/SAC Column -->
                                    <ng-container matColumnDef="HSN_SAC">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-100 sticky-header"> HSN/SAC </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-100" style="vertical-align: baseline;">
                                        <div class="cell-wrapper">
                                            <div class="cell-content">
                                                <input
                                                    type="text"
                                                    [(ngModel)]="item.hsn"
                                                    [ngClass]="{'form-control': true, 'error-border': item.errID.includes(12), 'normal': !item.errID.includes(12), 'error': item.errID.includes(12)}"
                                                    (blur)="validateField('hsn', item.srNo - 1)"
                                                    style="width: 100%; text-align: right"
                                                />
                                            </div>
                                            <div class="error-messages">
                                                <div *ngFor="let e of item.errors" style="margin-top: 2px;">
                                                    <span *ngIf="e.errID == 12" style="color: red;">• {{e.errorMsg}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        </td>
                                    </ng-container>
                            
                                    <!-- GST Column -->
                                    <ng-container matColumnDef="GST">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-80 sticky-header"> GST % </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-80" style="vertical-align: baseline;">
                                        <div class="cell-wrapper">
                                            <div class="cell-content">
                                                <input
                                                    type="text"
                                                    [(ngModel)]="item.gst"
                                                    [ngClass]="{'form-control': true, 'error-border': item.errID.includes(13), 'normal': !item.errID.includes(13), 'error': item.errID.includes(13)}"
                                                    (blur)="validateField('gst', item.srNo - 1)"
                                                    style="width: 100%; text-align: right"
                                                />
                                            </div>
                                            <div class="error-messages">
                                                <div *ngFor="let e of item.errors" style="margin-top: 2px;">
                                                    <span *ngIf="e.errID == 13" style="color: red;">• {{e.errorMsg}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        </td>
                                    </ng-container>
                            
                                    <!-- Description Column -->
                                    <ng-container matColumnDef="Description">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-200 sticky-header"> Description </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-200" style="vertical-align: baseline;">
                                            <div class="cell-wrapper">
                                                <div class="cell-content">
                                                    <input
                                                        type="text"
                                                        [(ngModel)]="item.desc"
                                                        [ngClass]="{'form-control': true, 'error-border': item.errID.includes(14), 'normal': !item.errID.includes(14), 'error': item.errID.includes(14)}"
                                                        (blur)="validateField('desc', item.srNo - 1)"
                                                        style="width: 100%;"
                                                    />
                                                </div>
                                                <div class="error-messages">
                                                    <div *ngFor="let e of item.errors" style="margin-top: 2px;">
                                                        <span *ngIf="e.errID == 14" style="color: red;">• {{e.errorMsg}}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </ng-container>
                            
                                    <!-- Source Column -->
                                    <ng-container matColumnDef="Source">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-100 sticky-header"> Source </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-120" style="vertical-align: baseline;">
                                            <select
                                                [(ngModel)]="item.source"
                                                [ngClass]="{'form-control': true, 'error-border': item.errID.includes(15), 'normal': !item.errID.includes(15), 'error': item.errID.includes(15)}"
                                                (blur)="validateField('source', item.srNo - 1)"
                                                style="width: 100%;"
                                            >
                                                <option value="" disabled selected>Select source</option>
                                                <option *ngFor="let source of purchaseTypes" [value]="source.type">{{ source.type }}</option>
                                            </select>
                                            <div class="error-messages">
                                                <div *ngFor="let e of item.errors" style="margin-top: 2px;">
                                                    <span *ngIf="e.errID == 15" style="color: red;">• {{e.errorMsg}}</span>
                                                </div>
                                            </div>
                                        </td>
                                    </ng-container>
                            
                                    <!-- Lead Time Column -->
                                    <ng-container matColumnDef="LeadTime">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-100 sticky-header"> Lead Time (Days) </th>                                       
                                        <td mat-cell *matCellDef="let item" class="data-cell w-100" style="vertical-align: baseline;">
                                        <div class="cell-wrapper">
                                            <div class="cell-content">
                                                <input
                                                    type="text"
                                                    [(ngModel)]="item.leadTime"
                                                    [ngClass]="{'form-control': true, 'error-border': item.errID.includes(16), 'normal': !item.errID.includes(16), 'error': item.errID.includes(16)}"
                                                    (blur)="validateField('leadTime', item.srNo - 1)"
                                                    style="width: 100%; text-align: right"
                                                />
                                            </div>
                                            <div class="error-messages">
                                                <div *ngFor="let e of item.errors" style="margin-top: 2px;">
                                                    <span *ngIf="e.errID == 16" style="color: red;">• {{e.errorMsg}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        </td>
                                    </ng-container>
                            
                                    <!-- Minimum Stock Column -->
                                    <ng-container matColumnDef="MinStock">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-100 sticky-header"> Min. Stock </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-100" style="vertical-align: baseline;">
                                        <div class="cell-wrapper">
                                            <div class="cell-content">
                                                <input
                                                    type="text"
                                                    [(ngModel)]="item.minStock"
                                                    [ngClass]="{'form-control': true, 'error-border': item.errID.includes(17), 'normal': !item.errID.includes(17), 'error': item.errID.includes(17)}"
                                                    (blur)="validateField('minStock', item.srNo - 1)"
                                                    style="width: 100%; text-align: right"
                                                />
                                            </div>
                                            <div class="error-messages">
                                                <div *ngFor="let e of item.errors" style="margin-top: 2px;">
                                                    <span *ngIf="e.errID == 17" style="color: red;">• {{e.errorMsg}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        </td>
                                    </ng-container>
                                    <!-- MRPPrice -->
                                    <ng-container matColumnDef="MRPPrice">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-100 sticky-header"> MRP Price </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-100" style="vertical-align: baseline;">
                                        <div class="cell-wrapper">
                                            <div class="cell-content">
                                                <input
                                                    type="text"
                                                    [(ngModel)]="item.mrpPrice"
                                                    [ngClass]="{'form-control': true, 'error-border': item.errID.includes(18), 'normal': !item.errID.includes(18), 'error': item.errID.includes(18)}"
                                                    (blur)="validateField('mrpPrice', item.srNo - 1)"
                                                    style="width: 100%; text-align: right"
                                                />
                                            </div>
                                            <div class="error-messages">
                                                <div *ngFor="let e of item.errors" style="margin-top: 2px;">
                                                    <span *ngIf="e.errID == 18" style="color: red;">• {{e.errorMsg}}</span>
                                                </div>
                                            </div>
                                        </div>
                                        </td>
                                    </ng-container>
                            
                                    <!-- Error Column -->
                                    <!-- <ng-container matColumnDef="Error">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-200 sticky-header"> Error </th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-200">
                                        <div class="error-content">{{item.errorMsg}}</div>
                                        </td>
                                    </ng-container> -->
                            
                                    <!-- Settings Column -->
                                    <!-- <ng-container matColumnDef="Settings">
                                        <th mat-header-cell *matHeaderCellDef class="header-cell w-50 sticky-header"></th>
                                        <td mat-cell *matCellDef="let item" class="data-cell w-50" style="vertical-align: baseline;">
                                        <a *ngIf="item.showSettings" href="/ERP/Categories" class="settings-button">
                                            <i class="fa fa-cog"></i>
                                        </a>
                                        </td>
                                    </ng-container> -->
                            
                                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                                    <tr mat-row *matRowDef="let item; columns: displayedColumns"></tr>
                                    </table>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
